/**
 * Notifi's selectable color family.
 *
 * These are intentionally soft surfaces rather than saturated utility colors.
 * UI rendered on top of them should use the paired dark ink whenever text or
 * icons need more than decorative contrast.
 */
export const NOTIFI_PASTEL_COLORS = [
  '#D9E5F2',
  '#DCEBDD',
  '#F3E8C9',
  '#F0D9D8',
  '#E6DDF0',
  '#F1DDE5',
  '#D9E8E8',
  '#E5ECD3',
  '#EEDCCF',
  '#D8D7D3',
] as const;

export const NOTIFI_STATUS_COLORS = {
  signal: { surface: '#F0D9D8', ink: '#873F44', border: '#D8A9AB' },
  success: { surface: '#DCEBDD', ink: '#315D3E', border: '#B9D3BE' },
  warning: { surface: '#F3E8C9', ink: '#6E5721', border: '#DDCA94' },
  info: { surface: '#D9E5F2', ink: '#3C5D78', border: '#B7CADC' },
  waiting: { surface: '#DFE5E8', ink: '#465D67', border: '#C3CFD4' },
  neutral: { surface: '#E8E6E1', ink: '#555552', border: '#D0CDC7' },
} as const;

export function readableForeground(background: string): '#111213' | '#FFFFFF' {
  const hex = background.trim().replace('#', '');
  if (!/^[\dA-Fa-f]{6}$/.test(hex)) return '#111213';

  const red = Number.parseInt(hex.slice(0, 2), 16);
  const green = Number.parseInt(hex.slice(2, 4), 16);
  const blue = Number.parseInt(hex.slice(4, 6), 16);
  const luminance = (0.2126 * red + 0.7152 * green + 0.0722 * blue) / 255;

  return luminance > 0.55 ? '#111213' : '#FFFFFF';
}
